import SolutionInput from './SolutionInput';

export default SolutionInput;